import {formsApiHostName} from "../endpoint";
import {defaultHeaders} from "../headers";

export const getAllSubmissions = async (formId) => {
  try {
    const result = await fetch(`${formsApiHostName}/forms/${formId}/submissions`, {
      method: "GET",
      headers: {
        ...defaultHeaders,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    });
    return {
      hasSuccess: result.status === 200,
      data: await result.json(),
    };
  } catch (error) {
    return {
      hasSuccess: false,
      data: error.message,
    };
  }
};
